import React from 'react';
import format from 'date-fns/format'
import {Grid, Typography} from "@mui/material";
import  config  from "../../config";
import {log} from "../../utils/log";
import {parseISO} from "date-fns";
import {estadoCivil, sexo} from "../../utils/utility";
//import Styles from '../../assets/scss/print.scss';


type Props = {
  text?: string,
  eilId: number,
  eId: number,
  aluno: any
 
};

type State = {
  checked: boolean,
};

const sxStyles = {
  marginGrid: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '30px',
    marginRight: '20px',
    padding: '0px'
    
  },
  mainGrid: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '30px',
    padding: '0px'
    
  },
  
  cabecalhoDados: {
    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', width: '50%'
  },

  fieldGrid: {
  
  },
  summary:{
    backgroundColor: '#c5c5c5'
  },
  disciplinaColuna: {
     display: 'flex',
     flexDirection: 'row',
     flexWrap: 'wrap',
      margin: '0px',
      padding: '0px'
  }
  
}


export class FichaMatriculaImpressao extends React.PureComponent< Props, State> {
  
  constructor( props:  Props) {
    super(props);
    
    this.state = { checked: false };
  }

  render() {
    const aluno =  this.props.aluno;
  
  //  log(3,"printable this.props.aluno object", this.props.eilId, this.props.eId, aluno);
  
    const {eId} = this.props;
    const ixdetail : any = aluno.enrollmentInLevel.findIndex((eil: any) => eil.id === this.props.eilId) ;
    
    if (ixdetail < 0) {
      return (<div><Typography variant={'caption'}>not found. {this.props.eId}</Typography>
      </div>)
    }
    
    if (!aluno || !this.props.eId || !aluno.enrollmentInLevel
          || aluno.enrollmentInLevel.length === 0 ||  !aluno.enrollmentInLevel[ixdetail].enrollment ) {
      return (<div><Typography variant={'caption'}>{this.props.eId}</Typography>
      </div>)
    }
    
    
    
    
  //  log(3,"enrollemtnmatricula",ixdetail);
    const data = aluno.enrollmentInLevel[ixdetail].enrollment.find((e: any) => e.id === this.props.eId) ;
    
  
//    log(3,"printable data", this.props.eId,  data);
 
 
 //   log(3,"printable this.props.aluno object", this.props.eId, aluno, data);
 
 
 //   log(3,'********* PRINTABLE ', data)
  
    let disccol1 : JSX.Element = <React.Fragment/>;
    let disccol2 : JSX.Element = <React.Fragment/>;
  
    if (data.disciplineEntree) {
      const disccol1Rows : any = [];
      const disccol2Rows : any = [];
    
      let x = 1;
    
      data.disciplineEntree.map((disp : any, key: number) => {
      
        log(4,'printable disciline', disp.disciplineOffer.classOffer.Description, disp);
        if (disp.Status === '' || disp.Status === null || disp.Status === 1) {
          var myRow =
              (<Grid key={key} item container sx={{...sxStyles.disciplinaColuna, width:'100%', margin: '0px', padding: '0px'}} >
                  <Grid item sx={{ width: '49%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>{disp.disciplineOffer.discipline.Description}</Typography>
                  </Grid>
                  <Grid item sx={{ width: '33%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>({disp.disciplineOffer.classOffer.Description})</Typography>
                  </Grid>
                  <Grid item sx={{ width: '18%', margin: '0px', padding: '0px'}}>
                      <Typography variant={'caption'}>{disp.id} - {disp.disciplineOffer.id}</Typography>
                  </Grid>
                {/*<td>({disp.})</td>*/}
              </Grid>);
          // if (x % 2) {
          //   disccol2Rows.push(myRow);
          //   x = x + 1;
          // } else {
             disccol1Rows.push(myRow);
          //   x = x + 1;
          // }
        }
      });
    
      disccol1 = (
          <Grid item sx={{...sxStyles.disciplinaColuna}} >
              {disccol1Rows}
           </Grid>
          
      );
    
      disccol2 = (
          <Grid item sx={{...sxStyles.disciplinaColuna}} >
              {disccol2Rows}
          </Grid>
      );
    }

 //   log(3,"FichaMatruloa returning...")
  
    return (
        <div className='print'>
          <Grid container sx={{...sxStyles.marginGrid}}>
          <Grid id='cabecalho' container sx={{...sxStyles.mainGrid}}>
            <Grid container item style={{ }}>
              <Grid container item style={{ width: '25%'}}>
                <img className="picture-src"
                     src="https://api-fermi.cientificoeducacao.com.br/api/PersonPics/fermi-images.cientificoeducacao.com.br/download/logoCientifico.png"
                     width={200} height={63}></img>
              </Grid>
              <Grid container item  sx={{ ...sxStyles.cabecalhoDados}}>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>SOCIEDADE EDUCACIONAL SÃO LEOPOLDO LTDA</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>EDUCAÇÃO DE JOVENS E ADULTOS</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>EAD
                  - {aluno.enrollmentInLevel[ixdetail] ? aluno.enrollmentInLevel[ixdetail].level.OfficialText : ""}</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>FICHA DE MATRÍCULA</Typography><br/>
                <Typography variant={'caption'} style={{ lineHeight: 0}}>PARECER
                  NUM {aluno.enrollmentInLevel[ixdetail] ? aluno.enrollmentInLevel[ixdetail].level.schoolAuthorization.OfficialNumber : ""}</Typography><br/>
              </Grid>
              <Grid container item className="alnright"  style={{ width: '25%'}}>
                { aluno.PictureFile &&
                  <img className="picture-src" src={config.BASE_URL + aluno.PictureFile} width={100} height={100}/>
                }
              </Grid>
            </Grid>
          </Grid>
        
          <Grid id='identificacao' container>
            <Grid container item >
              <Grid item style={{ width: '70%'}}>
                <Typography variant={'caption'}>ALUNO ({data ? data.id : ""}):</Typography>
                <Typography id='Aluno' className="fieldname">{aluno ? aluno.Name : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '15%'}}>
                <Typography variant={'caption'}>CPF:</Typography>
                <Typography className="fieldname" >{aluno ? aluno.IndividualIdentity : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '15%'}}>
                <Typography variant={'caption'}>CARNÊ:</Typography>
                <Typography id='Carne' className="fieldname">{data.PaymentCard ? data.PaymentCard : ""}</Typography>
              </Grid>
            </Grid>
          </Grid>
        
          <Grid id={'filiacao'} container>
            <Grid item style={{ width: '50%'}}>
                <Typography variant={'caption'}>Mãe:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.Mother : ""}</Typography>
            </Grid>
              <Grid item style={{ width: '50%'}}>
                <Typography variant={'caption'}>Pai:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.Father : ""}</Typography>
              </Grid>
          </Grid>
        
          <Grid id={'social'} container>
            <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Sexo:</Typography>
                  <Typography  variant={'caption'} className="fieldname">{aluno ? (aluno.Gender ? sexo(aluno.Gender) : "") : ""}</Typography>
            </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Estado Civil:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? (aluno.MaritalStatus ? estadoCivil(aluno.MaritalStatus) : "") : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Data Nascimento:</Typography>
                <Typography  variant={'caption'} className="fieldname">{aluno ? (aluno.BirthDate ? format(parseISO(aluno.BirthDate), "dd/MM/yyyy") : "") : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Natural de:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? (aluno.BirthPlace ? aluno.BirthPlace : " ") : " "}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Nacionalidade:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? (aluno.Nationality ? aluno.Nationality : " ") : " "}</Typography>
              </Grid>
            </Grid>
        
            <Grid id={'documentos'} container>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Identidade:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.IdentityNumber : " "}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Emissor:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.IdentityEmitter : " "}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Titulo:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ElectionIdentity : " "}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Zona:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ElectionZone : " "}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Identidade militar:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.MilitarIdentity : " "}</Typography>
              </Grid>
            </Grid>
          <br/>
          <Grid id={'endereco'} container>
            <Grid item style={{ width: '40%'}}>
                <Typography variant={'caption'}>Endereço Residencial:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? (aluno.Address ? aluno.Address : "") : ""}</Typography>
            </Grid>
            <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Número:</Typography><
               Typography variant={'caption'} className="fieldname">{aluno ? (aluno.StreetNumber ? aluno.StreetNumber : ' ') : ' '}</Typography>
            </Grid>
            <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Complemento:</Typography>
              <Typography variant={'caption'} className="fieldname">{aluno ? aluno.Address2 : ' '}</Typography>
            </Grid>
            <Grid item style={{ width: '25%'}}>
                <Typography variant={'caption'}>Bairro:</Typography>
              <Typography variant={'caption'} className="fieldname">{aluno ? aluno.Neighborhood : ' '}</Typography>
            </Grid>
            <Grid item style={{ width: '25%'}}>
                <Typography variant={'caption'}>Cidade:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.City : ' '}</Typography>
            </Grid>
            <Grid item style={{ width: '25%'}}>
                <Typography
                    variant={'caption'}>Estado:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.StateAddress : ' '}</Typography>
            </Grid>
            <Grid item style={{ width: '25%'}}>
                <Typography
                    variant={'caption'}>CEP:</Typography>
                 <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ZipCode : ' '}</Typography>
            </Grid>
            <Grid item style={{ width: '50%'}}>
                <Typography
                    variant={'caption'}>Celular:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.MobileNumber : ' '}</Typography>
            </Grid>
            <Grid item style={{ width: '50%'}}>
                <Typography variant={'caption'}>Telefone 2:</Typography>
                 <Typography variant={'caption'} className="fieldname">{aluno ? aluno.PhoneNumber : ' '}</Typography>
            </Grid>
          </Grid>
          <br/>
        
          <Grid id={'empresa'} container>
              <Grid item style={{ width: '100%'}}>
                <Typography variant={'caption'}>Empresa onde trabalha:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.WorkAt : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '40%'}}>
                <Typography variant={'caption'}>Endereço:</Typography>
                   <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ProfAddress : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography variant={'caption'}>Número:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ProfAddress2 : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '20%'}}>
                <Typography
                    variant={'caption'}>Complemento:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ProfAddress2 : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '25%'}}>
                <Typography
                    variant={'caption'}>Bairro:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ProfAddress2 : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '25%'}}>
                <Typography
                    variant={'caption'}>Cidade:</Typography>
                <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ProfCity : ""}</Typography>
              </Grid>
              <Grid item style={{ width: '25%'}}>
                <Typography
                    variant={'caption'}>Telefone:</Typography>
                  <Typography variant={'caption'} className="fieldname">{aluno ? aluno.ProfPhone : ""}</Typography>
              </Grid>
          </Grid>
          <br/>
          

            
            <Grid container style={{width: '100%'}}>
                <Grid item container style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', width: '100%', margin: '0px', padding: '0px'}}>
                    <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '62%', margin: '0px', padding: '0px'}}>
                        <Typography variant={'caption'}>SR. DIRETOR: Eu, {aluno ? aluno.Name : ""}, solicito matricula nos componentes curriculares abaixo
                            listados comprometendo-me a cumprir todas as disposições do Regimento Escolar.</Typography>
                    </Grid>
                    <Grid item container style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', width: '38%', margin: '0px', padding: '0px'}}>
                        <Typography variant={'caption'}>DOCUMENTOS NECESSARIOS</Typography>
                    </Grid>
                </Grid>
                <Grid item container style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap',  width: '100%', margin: '0px', padding: '0px'}}>
                    <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '62%', margin: '0px', padding: '0px', borderRight: '1px solid black'   }}>
                        {disccol1}
                    </Grid>
                    <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '38%', margin: '0px', paddingLeft: '10px'}}>
                        <Typography variant={'caption'}>_____ Histórico Escolar Ensino Fundamental</Typography>
                        <Typography variant={'caption'}>_____ Grade Curricular</Typography>
                        <Typography variant={'caption'}>_____ Histórico Escolar Ensino Médio</Typography>
                        <Typography variant={'caption'}>_____ Fotocópia Carteira Identidade </Typography>
                        <Typography variant={'caption'}>_____ Foto 3x4 </Typography>
                        <Typography variant={'caption'}>_____ CPF </Typography>
                        <Typography variant={'caption'}>_____ Atestado de Trabalho </Typography>
                        <Typography variant={'caption'}>_____ Comprovante Residência </Typography>
                        <Typography variant={'caption'}>_____ Certidão Nascimento ou Casamento </Typography>
                        <Typography variant={'caption'}>_____ Título Eleitoral </Typography>
                       
                    </Grid>
                </Grid>
            </Grid>
         
          <br/>
          
          <Grid id={'assinaturasERegistro'} item container style={{ display: 'flex', flexDirection: 'row',  width: '100%', margin: '0px', padding: '0px'}}>
              <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '62%', margin: '0px', padding: '0px'}}>
                  
                  <Grid item container style={{ display: 'flex', flexDirection: 'row',  width: '100%', margin: '0px', padding: '0px'}}>
                      <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '100%', margin: '0px', padding: '0px'}}>
                            <Typography variant={'caption'}>São Leopoldo, {data.enrollment?  (data.enrollment.Date? data.enrollment.Date: "") : ""}</Typography>
                      </Grid>
                      <br/>
                      <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '50%', margin: '0px', padding: '0px'}}>
                          <Typography variant={'caption'}>____________________________</Typography>
                          <Typography variant={'caption'}>pela Escola</Typography>
                      </Grid>
                      <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '50%', margin: '0px', padding: '0px'}}>
                            <Typography variant={'caption'}>____________________________</Typography>
                            <Typography variant={'caption'}>{aluno ? aluno.Name : ""}</Typography>
                      </Grid>
                  </Grid>
                    <br/>
                  <Grid item container style={{ display: 'flex', flexDirection: 'row',  width: '100%', margin: '0px', padding: '0px'}}>
                    <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '100%', margin: '0px', padding: '0px'}}>
                          <Typography variant={'caption'}>Comprometo-me a entregar os documentos acima assinalados no prazo de sete dias. A apresentação do
                              carnê, devidamente atualizado, é condição obrigatória para assistência às aulas.</Typography>
                    </Grid>
                      <Grid item container style={{ display: 'flex', flexDirection: 'row',  width: '100%', margin: '0px', padding: '0px'}}>
                          
                          <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '50%', margin: '0px', padding: '0px'}}>
                              <Typography variant={'caption'}>São Leopoldo, {data.enrollment?  (data.enrollment.Date? data.enrollment.Date: "") : ""}</Typography>
                          </Grid>
                          <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '50%', margin: '0px', padding: '0px'}}>
                              <Typography variant={'caption'}>____________________________</Typography>
                              <Typography variant={'caption'}>{aluno ? aluno.Name : ""}</Typography>
                          </Grid>
                      </Grid>
                  </Grid>
                  
              </Grid>
              <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '15%', margin: '0px', padding: '0px'}}>
              </Grid>
              <Grid item container style={{ display: 'flex', flexDirection: 'column',  width: '23%', margin: '0px', padding: '0px'}}>
                  <Typography variant={'caption'}>Classificação: ____________________</Typography>
                  <Typography variant={'caption'}>REGISTRO</Typography>
                  <Typography variant={'caption'}>Livro: ___________</Typography>
                  <Typography variant={'caption'}>Fls: ___________</Typography>
                  <Typography variant={'caption'}>No: ____________</Typography>
                  <Typography variant={'caption'}>Observações: ___________________________</Typography>
              </Grid>
              
              
          </Grid>
          
          
          
          
          
          
       
      
          </Grid>
        </div>
    );
  
  }

}



export default (FichaMatriculaImpressao)

export const FunctionalComponentToPrint = React.forwardRef<FichaMatriculaImpressao | null,  Props>((props, ref) => {
  // eslint-disable-line max-len
  log(3,"Execute FunctionalComponentToPrint");
  return <FichaMatriculaImpressao ref={ref} {...props} />;
});
